/* eslint-disable import/no-anonymous-default-export */
export default {
  API_ENDPOINT: "https://still-journey-41951.herokuapp.com/api",
  TOKEN_KEY: "maslool-client-auth-token",
};
